<template>
  <span>
    <v-chip
      v-if="text"
      small
      :style="chipStyle"
    >
      {{ formattedText }}
    </v-chip>
    <span
      v-else
      class="status-dot"
      :style="dotStyle"
    />
  </span>
</template>

<script>
const STATUS_MAP = {
  // Online / active states
  active:           { bg: '#D7FFE9', color: '#13DEB9' },
  Active:           { bg: '#D7FFE9', color: '#13DEB9' },
  online:           { bg: '#D7FFE9', color: '#13DEB9' },
  SLA_Met:           { bg: '#D7FFE9', color: '#13DEB9' },
  closed:           { bg: '#D7FFE9', color: '#13DEB9' },

  // Inactive / offline states
  inactive:         { bg: '#FEF5E5', color: '#FFAE20' },
  Inactive:         { bg: '#FEF5E5', color: '#FFAE20' },
  offline:          { bg: '#FDEDE8', color: '#FA896B' },
  Offline:          { bg: '#FDEDE8', color: '#FA896B' },

  // SLA states
  low:          { bg: '#E6F0FF', color: '#2B7FFF' },
  opened:          { bg: '#E6F0FF', color: '#2B7FFF' },
  on_time:          { bg: '#E6F0FF', color: '#2B7FFF' },
  On_Time:          { bg: '#E6F0FF', color: '#2B7FFF' },
  before_time:          { bg: '#E6F0FF', color: '#2B7FFF' },
  delayed:          { bg: '#FEF3E2', color: '#E27B1A' },
  critical:         { bg: '#FDEDE8', color: '#FA896B' },

  // Severity
  High:             { bg: '#FDEDE8', color: '#FA896B' },
  high:             { bg: '#FDEDE8', color: '#FA896B' },
  overdue:             { bg: '#FDEDE8', color: '#FA896B' },
  medium:           { bg: '#FEF5E5', color: '#FFAE20' },
  Medium:           { bg: '#FEF5E5', color: '#FFAE20' },
  pending:           { bg: '#FEF5E5', color: '#FFAE20' },
  acknowledged:           { bg: '#FEF5E5', color: '#FFAE20' },

  // Workflow states
  pending_approval: { bg: '#EDE4FF', color: '#9C94C6' },
  approved:         { bg: '#E8F7FF', color: '#49BEFF' },
  in_progress:      { bg: '#FEF5E5', color: '#FFAE20' },
  'In-Progress':    { bg: '#FEF5E5', color: '#FFAE20' },
  rejected:         { bg: '#FDEDE8', color: '#FA896B' },
  cancelled:        { bg: '#FDEDE8', color: '#FA896B' },
  late:        { bg: '#FDEDE8', color: '#FA896B' },
  Late_Departure:        { bg: '#FDEDE8', color: '#FA896B' },
  SLA_Not_Met:        { bg: '#FDEDE8', color: '#FA896B' },
  completed:        { bg: '#D7FFE9', color: '#35A79D' },
  Completed:        { bg: '#D7FFE9', color: '#35A79D' },
  rescheduled:      { bg: '#E5E2E2', color: '#8A8D93' },
};

const FALLBACK = { bg: '#E5E2E2', color: '#8A8D93' };

export default {
  props: {
    status: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    config() {
      return STATUS_MAP[this.status] ?? FALLBACK;
    },
    formattedText() {
      return this.text.replace(/[_-]/g, ' ');
    },
    chipStyle() {
      return {
        backgroundColor: this.config.bg,
        color: this.config.color,
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'capitalize',
        border: 'none',
      };
    },
    dotStyle() {
      return { backgroundColor: this.config.color };
    },
  },
};
</script>

<style lang="sass" scoped>
.status-dot
  display: inline-block
  border-radius: 50%
  width: 10px
  height: 10px
  margin-right: 0.4rem
  flex-shrink: 0

// Override Vuetify chip defaults so our inline styles take full control
.v-chip
  border: none !important
</style>
